'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Clock} from '../../../components/hocs/Clock';
import {DATE_HEADER, DateHeader, TODAY} from '../../../components/lists/DateHeader';
import {List} from '../../../components/lists/List';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {TimerLogItem} from '../TimerLogItem';


export function BaseTimerLogListView(props) {
  return (
    <List
      className={classNames("TimerLogList", props.className)}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {renderHeader(props)}
      {props.list ? props.list.map(model => (
        model.type === DATE_HEADER ? (
          <DateHeader
            key={getId(model)}
            date={model.date === TODAY ? props.todayLabel : model.date}
          />
        ) : (
          <TimerLogItem
            className={props.itemClassName}
            key={getId(model)}
            userId={props.userId}
            model={model}
            clock={props.clock}
          />
        )
      )) : null}
    </List>
  );
}

function renderHeader(props) {
  return (
    <div className="TimerLogList__header">
      <div className="TimerLogList__workerLabel">
        {props.workerLabel}
      </div>
      <div className="TimerLogList__startedLabel">
        {props.startedLabel}
      </div>
      <div className="TimerLogList__endedLabel">
        {props.endedLabel}
      </div>
      <div className="TimerLogList__durationLabel">
        {props.durationLabel}
      </div>
      <div className="TimerLogList__locationLabel">
        {props.locationLabel}
      </div>
    </div>
  );
}

BaseTimerLogListView.propTypes = {
  className: T.string,
  transitionGroupClass: T.string,
  itemClassName: T.string,

  placeholderTitle: T.string,
  todayLabel: T.string,
  workerLabel: T.string,
  startedLabel: T.string,
  endedLabel: T.string,
  durationLabel: T.string,
  locationLabel: T.string,

  init: T.bool,
};

BaseTimerLogListView.defaultProps = {
  init: true,
};

export const TimerLogListView = I18nComponent(Clock(BaseTimerLogListView, 60 * 1000), [
  {code: 'timers.feed.placeholder.label', prop: 'placeholderTitle'},
  {code: 'timers.feed.today.label', prop: 'todayLabel'},
  {code: 'timers.feed.worker.label', prop: 'workerLabel'},
  {code: 'timers.feed.started.label', prop: 'startedLabel'},
  {code: 'timers.feed.ended.label', prop: 'endedLabel'},
  {code: 'timers.feed.duration.label', prop: 'durationLabel'},
  {code: 'timers.feed.location.label', prop: 'locationLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerLogList/TimerLogListView.js